<div class="card">
  <p class="title">Alerta por canal</p>
  <p class="empty" *ngIf="isEmpty">No se encontraron datos</p>
  <div class="divChart" #alertChannel id="alertChannel">
    <canvas id="barChannel" height="300"></canvas>
  </div>
</div>
